import { InjectionToken } from '@angular/core';

export let APP_CONFIG = new InjectionToken('app.config');

export const AppConfig: any = {
  routes: {
    dashboard: 'dashboard',
    home: 'home',
    conversations: 'conversations',
    versionings: 'version-detail',
    memberProfile: {
      main: 'member-profile',
      conversations: 'conversations',
      tasks: 'tasks',
      notes: 'notes',
      info: 'info',
      contact: 'contact',
      accounts: 'accounts',
      sales: 'sales',
      documents: 'documents',
      account: (id: number, subType: string) => `${subType}/${id}`,
      profile: 'profile',
      offers: 'offers',
      access_history: 'access-history',
      credit_report: 'credit-report',
      application_list: 'application-list',
      assets: 'app-assets',
      liabilities: 'liabilities',
    },
    prospectProfile: {
      main: 'prospect-profile',
      conversations: 'conversations',
      tasks: 'tasks',
      notes: 'notes',
      info: 'info',
      contact: 'contact',
      accounts: 'accounts',
      documents: 'documents',
      profile: 'profile',
      access_history: 'access-history',
      credit_report: 'credit-report',
      application_list: 'application-list',
      assets: 'app-assets',
      liabilities: 'liabilities',
      // offers: 'offers',
    },
    elements: 'elements',
    error404: '404',
    memberManagement: {
      interactions: 'interactions',
      search: 'search',
      tasks: 'tasks',
      notes: 'notes',
      conversations: 'conversations',
      importConversation: 'import-conversation',
      conversationDetails: (id: number) => `conversations/${id}/edit`,
      conversationDetailsView: (id: number) => `conversations/${id}`,
      opportunities: 'opportunities',
      importOpportunities: 'import-opportunities',
      assignedApplications: 'assigned-applications',
      recentApplications: 'recent-applications',
      concerns: 'concerns',
      importConcern: 'import-concern',
      recentProfiles: 'recent-profiles',
      announcements: 'user-announcements',
      sales: 'sales',
      salesDetailsView: (id: number) => `sales/${id}`,
      salesDetails: (id: number) => `sales/${id}/edit`,
      importoffersdetail: 'import-offers-detail',
      importoffers: 'import-offers',
      offers: 'offers',
      OfferDetails: (id: number) => `offers/${id}/edit`,
      sqlBuilder: 'opportunity-engine',
    },
    contentManagement: {
      taskTemplates: 'task-templates',
      workflowTemplates: 'workflow-templates',
      emailTemplates: 'email-templates',
      campaignManagement: 'campaign-management',
      announcements: 'view-announcements',
      documentManagement: 'document-management',
      publicLinks: 'public-links',
      privateLinks: 'private-links',
      tagManagement: 'tag-management',
      ecm: 'ecm',
      offerTemplates: 'offer-templates',
      documentManagementSubMenu: {
        config: 'config',
        manageField: 'manage-field',
        signingSettings: 'signing-settings',
        changeLog: 'change-log',
      },
    },
    setup: {
      themeBuilder: 'theme-builder',
      branchManagement: 'branch-management',
      userManagement: 'user-management',
      userManagementDetails: (id: string) => `user-management/${id}`,
      userGroupManagement: 'user-group-management',
      userInformation: 'user-information',
      approvelModels: 'approval-models',
      rateModels: 'rate-models',
      declaration: 'setup/compliance-management/declaration',
      legalTerms: 'setup/compliance-management/legal-terms',
      eligibilityRule: 'setup/compliance-management/eligibility-rule',
      consent: 'setup/compliance-management/consent',
      documentConfiguration: 'document-configuration',
    },
    reports: {
      root: 'reports',
      saleReporting: 'reports/sale-reporting',
      opportunityReporting: 'reports/opportunity-reporting',
      pipelineReporting: 'reports/pipeline-reporting',
      interactionReporting: 'reports/interaction-reporting',
    },
    application: {
      applicationList: 'Application',
      applicationView: 'application-view',
      createApplication: 'create-application',
      general: 'general',
      lendingSummary: 'lending-summary',
      coreBanking: 'core-banking',
      product: 'product',
      applicant: 'applicant',
      assets: 'app-assets',
      liability: 'liability',
      document: 'document',
      notes: 'notes',
      changeLog: 'change-log',
      addAssets: 'add-assets',
    },
    configuration: {
      categoryManagement: 'category-management',
      productManagement:  'product-management',
      productTypeManagement: 'product-type-management',
      contentManagementConfiguration: 'content-management',
      productManagementSubMenu: {
        general: 'general',
        configuration: 'configuration',
        termRate: 'termRate',
        autoDecision: 'auto-decision',
        compliance: 'compliance',
        document: 'document',
        changeLog: 'change-log',
        crm: 'crm',
        coreBanking: 'core-banking'
      }
    },
    promoPage: {
      promopageList: 'promo-page',
    },
     changeLog: 'changeLog',
  },
};
